<template>
    <div v-show="isVisible">
        <slot></slot>
    </div>
</template>

<script>
    import Cookies from 'js-cookie';

    export default {
        props: {
            notificationId: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                visible: false,
                cookieString: `aha-alert-cookie-${this.notificationId}`
            }
        },
        computed: {
            isVisible: function() {
                return this.visible;
            }
        },
        mounted() {
            const alertCookie = Cookies.get(this.cookieString);

            if(typeof alertCookie == 'undefined') {

                let alertEl = window.document.querySelector('.c-alert');
                if (alertEl) {
                   alertEl.classList.add('c-alert__active');     
                }

                this.visible = true;

                this.$nextTick(() => {
                    this.$parent.$refs[this.notificationId].addEventListener('click', () => {
                        Cookies.set(this.cookieString, true);
                        this.visible = false;
                    });
                });
            } else {
                
            }

        }
    }
</script>


// WEBPACK FOOTER //
// src/app/components/aha-notification.vue